import { InjectionToken } from '@angular/core';

/**
 * Bridge interface for the AngularJS FeatureToggleService.
 * Used by AuthenticationService while the underlying service has not been migrated to Angular 18.
 */
export interface IFeatureTogglePort {
  fetch(): unknown;
}

export const FEATURE_TOGGLE_PORT = new InjectionToken<IFeatureTogglePort>('FEATURE_TOGGLE_PORT');
